import { ApiClient } from 'api/RestClient';
import { StatsLangRVO } from 'types/lang/main/StatsLangRVO';
import { doFetch } from 'util/AxiosUtil';

export const findStatsLang = async () => {
  return doFetch<StatsLangRVO>(ApiClient, `/api/stats/lang`).then((res) => res.data.response);
};
